var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 text-left backbutton"},[_c('router-link',{attrs:{"to":"/admin-panel"}},[_c('b-button',{attrs:{"variant":"secondary"}},[_c('i',{staticClass:"fa fa-arrow-left mr-1"}),_vm._v(" Back ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }